export default __webpack_public_path__ + "static/media/The Mark of Gwahlur.db9cc2df.jpg";